import { enumSCArrowVariants } from "../constants";
import { Globals } from "../CoreApp/Globals";
import { ScaleSCArrowForTouch } from "./ScaleSCArrowForTouch";

export function GetSCArrowHeight(variant, pub) {
  var height;
  if (variant == null) variant = Globals._scArrowStyle;
  if (variant == enumSCArrowVariants.miniarrow || variant == enumSCArrowVariants.themearrow)
    height = 10;
  else height = 15;

  height = ScaleSCArrowForTouch(height, pub);
  return height;
}
